import { render, staticRenderFns } from "./customerView.vue?vue&type=template&id=f183f8ac&scoped=true&"
import script from "./customerView.vue?vue&type=script&lang=js&"
export * from "./customerView.vue?vue&type=script&lang=js&"
import style0 from "./customerView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./customerView.vue?vue&type=style&index=1&id=f183f8ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f183f8ac",
  null
  
)

export default component.exports